<template>
    <div>
        <el-radio-group v-model="type" size="small">
            <el-radio-button :label="1">充值订单</el-radio-button>
            <el-radio-button :label="2">退款记录</el-radio-button>
            <el-radio-button :label="3">消耗记录</el-radio-button>
        </el-radio-group>
        <user-recharge-list v-if="type==1" :phone="phone" :userId="userId"></user-recharge-list>
        <user-refund-list v-if="type==2" :phone="phone" :userId="userId"></user-refund-list>
        <user-balance-use v-if="type==3" :phone="phone" :userId="userId"></user-balance-use>
    </div>
</template>

<script>
import UserBalanceUse from './user-balance-use.vue'
import userRechargeList from './user-recharge-list.vue'
import UserRefundList from './user-refund-list.vue'
export default {
  components: { userRechargeList, UserRefundList, UserBalanceUse },
    data() {
        return {
            type: 1
        }
    },
    props:['userId','phone'],
}
</script>

<style lang="scss" scoped>

</style>